import React, { type FC, type PropsWithChildren, memo } from 'react';
import cn from 'clsx';
import { DH } from '../../../../utils/DataHook';
import s from './styles.scss';

export const Container: FC<
  PropsWithChildren<{
    isLimitedWidth: boolean;
  }>
> = memo((props) => (
  <div
    className={cn(s.cardExpireDate, {
      [s.limitedWidth]: props.isLimitedWidth,
    })}
    data-hook={DH.Field.Container.Expiration}
  >
    {props.children}
  </div>
));
Container.displayName = 'Container';
